module.exports = __webpack_public_path__ + "img/grp-profile.b0dca153.png";